import { usePreloadImage } from '@fable/hooks'
import { css, useTheme } from '@fable/theme'

interface Props {
  image: string
}

export const MomBooksGridBookCover = ({ image }: Props) => {
  const { colors } = useTheme()
  const cover = usePreloadImage(image, 66)

  return (
    <img
      src={`${cover?.src}&mode=cors` || ''}
      alt="book"
      className={css`
        margin-left: -8px;
        width: 22px;
        height: 36px;
        object-fit: cover;
        border-radius: 2px;
        background-color: ${colors.uiWhite};
        border: 1px solid ${colors.uiGraphite};
      `}
    />
  )
}
